define(['edge/platform/base/BaseCtrl', 'edge/quoteandbind/common/models/Submission', 'moment'],
    (BaseCtrl, Submission, moment)=> {
        const fn = function ($scope, $rootScope, $state, $stateParams, LoadSaveService, ModalService, wizardFlowService,
                             qnbCompositeFlowDefn, ViewModelService, viewModelContext, returnStateFn, AvailabilityService) {
            const ctrl = Object.create(BaseCtrl);
            const parentWizardState = 'baseQnbWizard';

            ctrl.init = function () {               
                
                const stepToStateMapping = {
                    returnHome: model => returnStateFn(model),
                    confirmation: (model) => ['qnbconfirmation', {
                        quoteSummary: model.value,
                        returnStateInfo: returnStateFn(model.value)
                    }],
                    nextSteps: (model) => ['nextSteps', {
                    submission: model.value,
                    returnStateInfo: returnStateFn(model.value)
                }],
                    error: (model) => ['contactUs', {
                        errorMsg: (model)? model.draftData.lobs.value.exception:'',
                        quoteID: (model) ? model.quoteID.value : null
                    }]
                };
                const flowfactory = wizardFlowService(qnbCompositeFlowDefn, parentWizardState, stepToStateMapping);

                if ($stateParams.quoteID) {//resume draft submission
                    
                    // Check zipcode availability before retrieve submission
                    // Passing dummy productCode to avoid DTO validation error in back end
                    var availabilityRequest = {
                        effectiveDate: new Date(),
                        postalCode: $stateParams.postalCode,
                        productCode: 'PersonalAuto'
                    };
                    
                    const availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode('quoteandbind', availabilityRequest);
                    ModalService.showProgressDialog('quoteandbind.controllers.QuoteEntryCtrl.Retrieving draft submission...', availabilityPromise);
                    availabilityPromise.then(availabilityResponse => {
                        
                        if(availabilityResponse.isAvailable){                       
                    
                            const submissionLoadPromise = LoadSaveService.retrieveSubmission('quoteandbind', $stateParams);
                            ModalService.showProgressDialog('quoteandbind.controllers.QuoteEntryCtrl.Retrieving draft submission...', submissionLoadPromise);

                            submissionLoadPromise.then(submissionData => {
                                // Check the quote has expired or not, if expired then display error message
                                if (submissionData.quoteStatus == 'Expired') {
                                    
                                    const errorPromise = ModalService.showError(
                                            'quoteandbind.controllers.ZipCodeCtrl.Error',
                                            'quoteandbind.controllers.ZipCodeCtrl.Quote Expired').result;
                                            
                                    $rootScope["isValidZipCodeRequest"] = true;
                                            
                                    errorPromise.then(() => {
                                        //return the home page
                                        $state.go('zipCode');
                                    });
                                    
                                    return;
                                } 
                                //commenting to test default eff dt --Arpita Sengupta
                                // if ($stateParams.shouldUpdateEffectiveDate && moment(submissionData.draftData.periodStartDate).isBefore(moment(), 'day')) {
                                //     submissionData.draftData.periodStartDate = new Date();
                                // }
                                //ended
                                const submission = new Submission(submissionData);
                                const submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);
                                flowfactory.resume(submissionVM, $stateParams);
                            }).catch((errorResponse) => {
                                
                                // Get response data
                                var responseData = errorResponse[0].baseError.data;
                                // Check if the response data has error message object
                                // then check the error message and error app code
                                // display the error message based on the error message and error app code
                                if (angular.isObject(responseData) && responseData.error.message == 'Submission not found') {
                                    
                                    const errorPromise = ModalService.showError(
                                            'quoteandbind.controllers.ZipCodeCtrl.Error',
                                            'quoteandbind.controllers.ZipCodeCtrl.Please enter your valid quote number to proceed.').result;
                                    
                                    $rootScope["isValidZipCodeRequest"] = true;
                                    
                                    errorPromise.then(() => {
                                        //return the home page
                                        $state.go('zipCode');
                                    });
                                }
                                // check if response data is string (i.e HTTP error page)
                                // then we are getting no response from server
                                else {
                                    
                                    const errorPromise = ModalService.showError(
                                            'quoteandbind.controllers.ZipCodeCtrl.Error',
                                            'quoteandbind.controllers.ZipCodeCtrl.PC system down error').result;
                                    
                                    $rootScope["isValidZipCodeRequest"] = true;
                                    
                                    errorPromise.then(() => {
                                        //return the home page
                                        $state.go('zipCode');
                                    });
                                }
                                
                                /*const errorPromise = ModalService.showError(
                                    'quoteandbind.controllers.QuoteEntryCtrl.Error retrieving submission',
                                    'quoteandbind.controllers.QuoteEntryCtrl.Sorry, but we can\'t seem to locate a quote with that number and that ZIP code. Please try again.'
                                ).result;
                                errorPromise.then(() => {
                                    //return the home page
                                    $state.go('zipCode');
                                });*/
                            });
                        }
                        else{
                            //Show user error page explaining that the product isn't available
                           /* ModalService.showError(
                                    'quoteandbind.controllers.ZipCodeCtrl.Error',
                                    'quoteandbind.controllers.ZipCodeCtrl.We do not recognize the zipcode entered, please try again.').result;*/

                        ModalService.showError(
                            'quoteandbind.controllers.ZipCodeCtrl.Error',
                            'It seems you have entered a zip code not within the region of AAA Carolinas. Please try again or click '+
                            '<a target="_blank" href="http://www.aaa.com/stop">here</a>'+' and reenter your zip code to find the AAA Club in your state.').result;
                            
                            $rootScope["isValidZipCodeRequest"] = true;        
                            
                            //errorPromise.then(() => {
                                //return the home page
                                $state.go('zipCode');
                            //});
                        }
                            
                    }).catch((e) => {
                        
                        const errorPromise = ModalService.showError(
                            'quoteandbind.controllers.ZipCodeCtrl.Error',
                            'quoteandbind.controllers.ZipCodeCtrl.PC system down error'
                        ).result;
                
                        $rootScope["isValidZipCodeRequest"] = true;
                
                        errorPromise.then(() => {
                            //return the home page
                            $state.go('zipCode');
                        });
                
                    });
                            
                            
                } else {      
                    const submission = new Submission();
                    submission.draftData.productCode = $stateParams.productCode;
                    if ($stateParams.account) {
                        submission.draftData.accountHolder = $stateParams.account;
                        //submission.draftData.accountNumber = $stateParams.account.accountNumber;
                        submission.draftData.policyAddress = $stateParams.account.primaryAddress;
                    }
                    const submissionModel = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);
                    flowfactory.start(submissionModel, $stateParams);
                }
            };

            return ctrl.create($scope);
        };
        fn.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'qnb.LoadSaveService', 'ModalService', 'WizardFlowService',
            'qnb.CompositeFlowDefn', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.returnStateFn','AvailabilityService'];

        return fn;
    });



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/QuoteEntryCtrl.js
 **/